import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Badge,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { GetData, PostData, PutData } from "../../services/api";
import Swal from "sweetalert2";
import Loader from "../../components/Common/Loader";

import {
  addNewEvent as onAddNewEvent,
  deleteEvent as onDeleteEvent,
  getCategories as onGetCategories,
  getEvents as onGetEvents,
  updateEvent as onUpdateEvent,
  resetCalendar,
} from "../../store/actions";

import DeleteModal from "./DeleteModal";

//css
// import "@fullcalendar/bootstrap/main.css";
import "./calendar.css";

//redux
import { useSelector, useDispatch } from "react-redux";

const Calender = (props) => {
  const dispatch = useDispatch();

  const [event, setEvent] = useState({});

  // events validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (event && event.title) || "",
      category: (event && event.category) || "",
      location: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Por favor ingresa el nombre del evento"),
      category: Yup.string().required("Por favor selecciona una categoría"),
    }),
    onSubmit: (values) => {
      // Obtener el color correspondiente a la categoría
      const categoryColors = {
        'bg-primary': '#E9553E',
        'bg-success': '#0ac074',
        'bg-warning': '#fcb92c',
        'bg-danger': '#ff3d60',
        'bg-info': '#4aa3ff',
        'bg-dark': '#343a40',
        'bg-secondary': '#74788d',
      };
      
      const borderColor = categoryColors[values.category] || '#E9553E';
      
      if (isEdit) {
        const updateEvent = {
          id: event.id,
          title: values.title,
          classNames: values.category,
          start: event.start,
          borderColor: borderColor,
          backgroundColor: '#ffffff',
          textColor: '#495057',
        };
        // update event
        dispatch(onUpdateEvent(updateEvent));
        validation.resetForm();
      } else {
        const newEvent = {
          id: Math.floor(Math.random() * 100000),
          title: values["title"],
          start: selectedDay ? selectedDay.date : new Date(),
          className: values.category,
          borderColor: borderColor,
          backgroundColor: '#ffffff',
          textColor: '#495057',
        };
        // save new event
        dispatch(onAddNewEvent(newEvent));
        validation.resetForm();
      }
      setSelectedDay(null);
      toggle();
    },
  });

  // category validation
  const categoryValidation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (event && event.title) || "",
      category: (event && event.category) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Order Id"),
      category: Yup.string().required("Please Enter Your Billing Name"),
    }),
    onSubmit: (values) => {
      const newEvent = {
        id: Math.floor(Math.random() * 100),
        title: values["title"],
        start: selectedDay ? selectedDay.date : new Date(),
        className: values.category + " text-white",
      };
      // save new event

      dispatch(onAddNewEvent(newEvent));
      categoryValidation.resetForm();
      toggleCategory();
    },
  });

  const { categories, isEventUpdated } = useSelector((state) => ({
    categories: state.calendar.categories,
    isEventUpdated: state.calendar.isEventUpdated,
  }));

  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalcategory, setModalcategory] = useState(false);

  const [selectedDay, setSelectedDay] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  
  // Estados para sincronización
  const [calendarProviders, setCalendarProviders] = useState([]);
  const [syncing, setSyncing] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [backendEvents, setBackendEvents] = useState([]);
  const [syncDropdownOpen, setSyncDropdownOpen] = useState(false);
  const [eventDetailsModal, setEventDetailsModal] = useState(false);
  const [selectedEventDetails, setSelectedEventDetails] = useState(null);
  const [selectedEventType, setSelectedEventType] = useState(null);
  const [leads, setLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [meetingType, setMeetingType] = useState("presencial");
  const [meetingPlatform, setMeetingPlatform] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [leadSearchTerm, setLeadSearchTerm] = useState("");
  const [notes, setNotes] = useState("");
  const [userTimezone, setUserTimezone] = useState("America/Mexico_City");

  // Cargar zona horaria del usuario
  useEffect(() => {
    const loadUserTimezone = async () => {
      try {
        const response = await GetData("/users/profile");
        if (response?.data?.timezone) {
          setUserTimezone(response.data.timezone);
        }
      } catch (error) {
        console.error("Error loading user timezone:", error);
        // Usar default si hay error
        setUserTimezone("America/Mexico_City");
      }
    };
    loadUserTimezone();
  }, []);

  // Cargar proveedores de calendario
  const loadCalendarProviders = async () => {
    try {
      const response = await GetData("/calendar/providers");
      const providers = response?.data || [];
      console.log("All providers from API:", providers);
      const connectedProviders = providers.filter((p) => p.status === "connected");
      console.log("Connected providers:", connectedProviders);
      setCalendarProviders(connectedProviders);
    } catch (error) {
      console.error("Error loading calendar providers:", error);
      setCalendarProviders([]);
    }
  };

  // Cargar eventos del backend
  const loadBackendEvents = async () => {
    setLoadingEvents(true);
    try {
      const now = new Date();
      const endDate = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000); // 90 días adelante
      
      const response = await GetData(
        `/calendar/events?startDate=${now.toISOString()}&endDate=${endDate.toISOString()}`
      );
      
      if (response?.data?.data) {
        const events = response.data.data.map((event) => ({
          id: event.id,
          title: event.title,
          start: event.startDate,
          end: event.endDate,
          allDay: event.allDay || false,
          backgroundColor: "#fff5f3",
          borderColor: event.color || "#E9553E",
          textColor: "#495057",
          borderWidth: 2,
          classNames: ["backend-event"],
          extendedProps: {
            description: event.description,
            location: event.location,
            attendees: event.attendees,
            attendeesInfo: event.attendeesInfo || [],
            meetingUrl: event.meetingUrl,
            type: event.type, // Tipo de evento (bg-primary, bg-info, etc.)
            isBackendEvent: true, // Marcar como evento del backend
            eventColor: event.color || "#E9553E", // Guardar color original para el indicador
          },
        }));
        setBackendEvents(events);
      }
    } catch (error) {
      console.error("Error loading backend events:", error);
    } finally {
      setLoadingEvents(false);
    }
  };

  // Cargar leads basado en búsqueda
  const loadLeads = async (searchTerm = "") => {
    if (!searchTerm || searchTerm.trim().length === 0) {
      setLeads([]);
      setLoadingLeads(false);
      return;
    }

    setLoadingLeads(true);
    try {
      // Buscar leads por nombre, apellido, email o teléfono
      const response = await GetData(`/customers?limit=100&offset=0&search=${encodeURIComponent(searchTerm.trim())}`);
      if (response?.data?.data) {
        setLeads(response.data.data);
      } else {
        setLeads([]);
      }
    } catch (error) {
      console.error("Error loading leads:", error);
      setLeads([]);
    } finally {
      setLoadingLeads(false);
    }
  };

  // Cargar leads cuando cambie el término de búsqueda (con debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (leadSearchTerm && leadSearchTerm.trim().length > 0) {
        loadLeads(leadSearchTerm);
      } else {
        setLeads([]);
        setLoadingLeads(false);
      }
    }, 500); // Esperar 500ms después de que el usuario deje de escribir

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadSearchTerm]);

  useEffect(() => {
    dispatch(onGetCategories());
    // Eliminado dispatch(onGetEvents()) - solo usamos eventos del backend
    loadCalendarProviders();
    loadBackendEvents();
    
    new Draggable(document.getElementById("external-events"), {
      itemSelector: ".external-event",
    });
  }, [dispatch]);

  useEffect(() => {
    if (isEventUpdated) {
      setIsEdit(false);
      setEvent({});
      setTimeout(() => {
        dispatch(resetCalendar("isEventUpdated", false));
      }, 500);
    }
  }, [dispatch, isEventUpdated]);

  // Función para sincronizar con un proveedor específico
  const handleSyncCalendar = async (providerId) => {
    if (!providerId) return;

    setSyncing(true);
    try {
      const response = await PostData("/calendar/events/sync", {
        calendarProviderId: providerId,
      });

      if (response?.data) {
        const { synced, created, updated, errors } = response.data;
        
        Swal.fire({
          icon: "success",
          title: "¡Sincronización completada!",
          html: `
            <p><strong>Eventos sincronizados:</strong> ${synced}</p>
            <p><strong>Creados:</strong> ${created}</p>
            <p><strong>Actualizados:</strong> ${updated}</p>
            ${errors > 0 ? `<p><strong>Errores:</strong> ${errors}</p>` : ""}
          `,
          confirmButtonColor: "#E9553E",
        });

        // Recargar eventos después de sincronizar
        await loadBackendEvents();
      }
    } catch (error) {
      console.error("Error syncing calendar:", error);
      Swal.fire({
        icon: "error",
        title: "Error al sincronizar",
        text: error.message || "No se pudo sincronizar el calendario",
        confirmButtonColor: "#E9553E",
      });
    } finally {
      setSyncing(false);
      setSyncDropdownOpen(false);
    }
  };

  // Sincronizar todos los proveedores
  const handleSyncAll = async () => {
    if (calendarProviders.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin proveedores",
        text: "No hay proveedores de calendario configurados",
        confirmButtonColor: "#E9553E",
      });
      return;
    }

    setSyncing(true);
    let totalSynced = 0;
    let totalCreated = 0;
    let totalUpdated = 0;
    let totalErrors = 0;

    try {
      for (const provider of calendarProviders) {
        if (provider.id) {
          try {
            const response = await PostData("/calendar/events/sync", {
              calendarProviderId: provider.id,
            });

            if (response?.data) {
              totalSynced += response.data.synced || 0;
              totalCreated += response.data.created || 0;
              totalUpdated += response.data.updated || 0;
              totalErrors += response.data.errors || 0;
            }
          } catch (error) {
            console.error(`Error syncing ${provider.displayName}:`, error);
            totalErrors++;
          }
        }
      }

      Swal.fire({
        icon: "success",
        title: "¡Sincronización completada!",
        html: `
          <p><strong>Eventos sincronizados:</strong> ${totalSynced}</p>
          <p><strong>Creados:</strong> ${totalCreated}</p>
          <p><strong>Actualizados:</strong> ${totalUpdated}</p>
          ${totalErrors > 0 ? `<p><strong>Errores:</strong> ${totalErrors}</p>` : ""}
        `,
        confirmButtonColor: "#E9553E",
      });

      // Recargar eventos después de sincronizar
      await loadBackendEvents();
    } catch (error) {
      console.error("Error syncing calendars:", error);
      Swal.fire({
        icon: "error",
        title: "Error al sincronizar",
        text: error.message || "No se pudo sincronizar los calendarios",
        confirmButtonColor: "#E9553E",
      });
    } finally {
      setSyncing(false);
      setSyncDropdownOpen(false);
    }
  };

  /**
   * Handling the modal state
   */
  const toggle = () => {
    if (modal) {
      setModal(false);
      setEvent(null);
      setIsEdit(false);
      setSelectedEventType(null);
      setSelectedLeads([]);
      setMeetingType("presencial");
      setMeetingPlatform("");
      setEventTime("");
      setEventDate("");
      setLeadSearchTerm("");
      setNotes("");
    } else {
      setModal(true);
    }
  };

  const toggleCategory = () => {
    setModalcategory(!modalcategory);
  };

  /**
   * Handling date click on calendar
   */
  const handleDateClick = (arg) => {
    const date = arg["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    // Formatear fecha para el input
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    setEventDate(dateStr);

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(
      year,
      month,
      day,
      currentHour,
      currentMin,
      currentSec
    );
    const modifiedData = { ...arg, date: modifiedDate };

    setSelectedDay(modifiedData);
    setSelectedEventType(null); // Resetear tipo de evento
    toggle();
  };

  /**
   * Handling click on event on calendar
   */
  // Función para cargar datos del evento y preparar el formulario de edición
  const loadEventForEditing = async (eventId, eventData) => {
    const startDate = new Date(eventData.startDate);
    const endDate = new Date(eventData.endDate);
    
    // Formatear fecha y hora para los inputs
    const dateStr = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
    const timeStr = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`;
    
    setEventDate(dateStr);
    setEventTime(timeStr);
    
    // Determinar el tipo de evento: usar el campo type si existe, sino inferir del color
    let eventType = eventData.type;
    if (!eventType) {
      // Fallback: determinar el tipo de evento basado en el color (para eventos antiguos)
      const colorToType = {
        '#E9553E': 'bg-primary',
        '#0ac074': 'bg-success',
        '#fcb92c': 'bg-warning',
        '#ff3d60': 'bg-danger',
        '#4aa3ff': 'bg-info',
        '#343a40': 'bg-dark',
        '#74788d': 'bg-secondary',
      };
      eventType = colorToType[eventData.color] || 'bg-primary';
    }
    setSelectedEventType(eventType);
    
    // Solo configurar tipo de reunión si es bg-info o tiene meetingUrl/calendarProviderId
    const isReunion = eventType === 'bg-info' || !!eventData.meetingUrl || !!eventData.calendarProviderId;
    if (isReunion) {
      // Determinar si es virtual o presencial basado en meetingUrl y location
      const isVirtual = !!eventData.meetingUrl || !!eventData.calendarProviderId;
      setMeetingType(isVirtual ? "virtual" : "presencial");
      
      // Si es virtual, intentar determinar la plataforma
      if (isVirtual && eventData.calendarProviderId && calendarProviders.length > 0) {
        const eventProvider = calendarProviders.find(p => p.id === eventData.calendarProviderId);
        if (eventProvider) {
          setMeetingPlatform(eventProvider.key);
        }
      }
    } else {
      // Si no es reunión, resetear estos valores
      setMeetingType("presencial");
      setMeetingPlatform("");
    }
    
    // Cargar leads seleccionados desde attendeesInfo o attendees
    if (eventData.attendeesInfo && eventData.attendeesInfo.length > 0) {
      const leadsFromAttendees = eventData.attendeesInfo
        .filter(att => att.email)
        .map(att => ({
          id: att.customerId || att.email,
          name: att.name || '',
          lastName: att.lastName || '',
          email: att.email,
        }));
      setSelectedLeads(leadsFromAttendees);
    } else if (eventData.attendees && eventData.attendees.length > 0) {
      // Si no hay attendeesInfo, intentar buscar los leads por email
      try {
        const leadsPromises = eventData.attendees.map(async (email) => {
          try {
            const leadResponse = await GetData(`/customers?email=${encodeURIComponent(email)}&limit=1`);
            if (leadResponse?.data?.data && leadResponse.data.data.length > 0) {
              const lead = leadResponse.data.data[0];
              return {
                id: lead.id,
                name: lead.name || '',
                lastName: lead.lastName || '',
                email: lead.email,
              };
            }
            return {
              id: email,
              name: '',
              lastName: '',
              email: email,
            };
          } catch (err) {
            return {
              id: email,
              name: '',
              lastName: '',
              email: email,
            };
          }
        });
        const loadedLeads = await Promise.all(leadsPromises);
        setSelectedLeads(loadedLeads.filter(lead => lead));
      } catch (err) {
        console.error("Error loading leads:", err);
        setSelectedLeads([]);
      }
    } else {
      setSelectedLeads([]);
    }
    
    // Extraer notas del campo description
    let notesText = "";
    if (eventData.description) {
      // Buscar si hay "Notas: " en la descripción
      const notesMatch = eventData.description.match(/Notas:\s*(.+)/s);
      if (notesMatch) {
        notesText = notesMatch[1].trim();
      } else {
        // Si no tiene el prefijo "Notas:", pero no es una descripción de reunión, usar toda la descripción
        const isReunionDescription = eventData.description.includes("Reunión virtual") || 
                                      eventData.description.includes("Google Meet") || 
                                      eventData.description.includes("Zoom");
        if (!isReunionDescription) {
          notesText = eventData.description.trim();
        }
      }
    }
    setNotes(notesText);
    
    // Establecer el evento para edición
    setEvent({
      id: eventId,
      title: eventData.title,
      isBackendEvent: true,
      backendEventData: {
        description: eventData.description,
        location: eventData.location,
        meetingUrl: eventData.meetingUrl,
        calendarProviderId: eventData.calendarProviderId,
        color: eventData.color,
      },
    });
    
    // Establecer valores del formulario
    validation.setFieldValue("title", eventData.title);
    if (eventData.location) {
      validation.setFieldValue("location", eventData.location);
    }
    
    setIsEdit(true);
  };

  const handleEventClick = async (arg) => {
    const event = arg.event;
    const extendedProps = event.extendedProps || {};
    
    // Si es un evento del backend, mostrar modal de detalles primero
    if (extendedProps.isBackendEvent) {
      // Cargar datos completos del evento desde el backend
      try {
        const response = await GetData(`/calendar/events/${event.id}`);
        const eventData = response?.data;
        
        if (eventData) {
          // Mapear tipo de evento a nombre legible
          const eventTypeNames = {
            'bg-primary': 'Enviar Correo',
            'bg-info': 'Nueva Reunión',
            'bg-success': 'Llamar',
            'bg-warning': 'Seguimiento',
            'bg-danger': 'Tarea',
            'bg-dark': 'Visita',
          };
          
          // Mostrar modal de detalles
          setSelectedEventDetails({
            id: event.id,
            title: eventData.title,
            description: eventData.description,
            start: eventData.startDate,
            end: eventData.endDate,
            location: eventData.location,
            meetingUrl: eventData.meetingUrl,
            attendees: eventData.attendees || [],
            attendeesInfo: eventData.attendeesInfo || [],
            type: eventData.type,
            typeName: eventTypeNames[eventData.type] || 'Evento',
            isBackendEvent: true,
            eventData: eventData, // Guardar datos completos para edición
          });
          setEventDetailsModal(true);
          return;
        }
      } catch (error) {
        console.error("Error loading event:", error);
        const errorMessage = error.response?.data?.error?.message || error.message || "No se pudo cargar el evento";
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
          confirmButtonColor: "#E9553E",
        });
        return;
      }
    }
    
    // Para eventos locales (Redux), usar el flujo normal
    setEvent({
      id: event.id,
      title: event.title,
      title_category: event.title_category,
      start: event.start,
      className: event.classNames,
      category: event.classNames[0],
    });
    setIsEdit(true);
    toggle();
  };

  /**
   * On delete event
   */
  const handleDeleteEvent = () => {
    dispatch(onDeleteEvent(event));
    setDeleteModal(false);
    toggle();
  };

  /**
   * Handle event form submission
   */
  const handleEventSubmit = async () => {
    if (!validation.values.title) {
      validation.setFieldTouched("title", true);
      return;
    }

    if (!selectedEventType && !isEdit) {
      validation.setFieldTouched("category", true);
      return;
    }

    const categoryType = selectedEventType || validation.values.category;
    const categoryColors = {
      'bg-primary': '#E9553E',
      'bg-success': '#0ac074',
      'bg-warning': '#fcb92c',
      'bg-danger': '#ff3d60',
      'bg-info': '#4aa3ff',
      'bg-dark': '#343a40',
      'bg-secondary': '#74788d',
    };
    
    const borderColor = categoryColors[categoryType] || '#E9553E';

    // Validar que todos los eventos (excepto Tarea/bg-danger) tengan al menos un lead
    if (categoryType !== "bg-danger" && selectedLeads.length === 0 && !isEdit) {
      Swal.fire({
        icon: "warning",
        title: "Lead requerido",
        text: "Debes seleccionar al menos un lead para este tipo de evento",
        confirmButtonColor: "#E9553E",
      });
      return;
    }

    // Validar fecha y hora
    if (!eventDate || !eventTime) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Por favor selecciona fecha y hora",
        confirmButtonColor: "#E9553E",
      });
      return;
    }

    // Validar que la fecha y hora no sean anteriores a ahora usando la zona horaria del usuario
    const timezone = userTimezone || "America/Mexico_City";
    
    // Obtener la fecha/hora actual en la zona horaria del usuario
    const now = new Date();
    const nowInTz = new Intl.DateTimeFormat("en-CA", {
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    }).formatToParts(now);
    
    const nowYear = parseInt(nowInTz.find(p => p.type === "year").value);
    const nowMonth = parseInt(nowInTz.find(p => p.type === "month").value) - 1;
    const nowDay = parseInt(nowInTz.find(p => p.type === "day").value);
    const nowHour = parseInt(nowInTz.find(p => p.type === "hour").value);
    const nowMin = parseInt(nowInTz.find(p => p.type === "minute").value);
    
    // Crear la fecha seleccionada
    const [year, month, day] = eventDate.split('-').map(Number);
    const [hours, minutes] = eventTime.split(':').map(Number);
    
    // Comparar en la zona horaria del usuario
    const nowInUserTimezone = new Date(nowYear, nowMonth, nowDay, nowHour, nowMin, 0);
    const selectedInUserTimezone = new Date(year, month - 1, day, hours, minutes, 0);
    
    // Agregar un margen de 1 minuto para evitar problemas de precisión
    const margin = 60 * 1000; // 1 minuto en milisegundos
    const nowWithMargin = new Date(nowInUserTimezone.getTime() - margin);
    
    // Si la fecha seleccionada es anterior a ahora (con margen), mostrar error
    if (selectedInUserTimezone <= nowWithMargin) {
      const selectedDateOnly = new Date(year, month - 1, day, 0, 0, 0, 0);
      const todayOnly = new Date(nowYear, nowMonth, nowDay, 0, 0, 0, 0);
      
      if (selectedDateOnly < todayOnly) {
        // La fecha es anterior a hoy
        Swal.fire({
          icon: "error",
          title: "Fecha inválida",
          text: "No se pueden crear eventos con fechas anteriores a hoy. Por favor selecciona una fecha actual o futura.",
          confirmButtonColor: "#E9553E",
        });
      } else {
        // La fecha es hoy pero la hora es anterior
        Swal.fire({
          icon: "error",
          title: "Hora inválida",
          text: "No se pueden crear eventos con hora anterior a la hora actual. Por favor selecciona una hora futura.",
          confirmButtonColor: "#E9553E",
        });
      }
      return;
    }

    // Si es edición de un evento del backend
    if (isEdit && event?.isBackendEvent) {

      // Solo validar plataforma si es una reunión (bg-info o tiene meetingUrl/calendarProviderId)
      const isReunion = selectedEventType === "bg-info" || !!event?.backendEventData?.meetingUrl || !!event?.backendEventData?.calendarProviderId;
      if (isReunion && meetingType === "virtual" && !meetingPlatform) {
        Swal.fire({
          icon: "warning",
          title: "Plataforma requerida",
          text: "Por favor selecciona una plataforma para la reunión virtual",
          confirmButtonColor: "#E9553E",
        });
        return;
      }

      try {
        // Combinar fecha y hora
        const dateTime = new Date(`${eventDate}T${eventTime}`);
        const endDateTime = new Date(dateTime.getTime() + 60 * 60 * 1000); // 1 hora por defecto

        // Obtener el proveedor de calendario si es virtual y es reunión
        let calendarProviderId = event.backendEventData?.calendarProviderId || null;
        if (isReunion) {
          if (meetingType === "virtual" && meetingPlatform) {
            const provider = calendarProviders.find(p => p.key === meetingPlatform);
            if (provider) {
              calendarProviderId = provider.id;
            }
          } else if (meetingType === "presencial") {
            calendarProviderId = null;
          }
        } else {
          calendarProviderId = null;
        }

        // Preparar datos del evento para actualizar
        // Solo incluir campos de reunión si es bg-info o tiene meetingUrl/calendarProviderId
        let description = "";
        if (isReunion) {
          description = meetingType === "virtual" 
            ? `Reunión virtual vía ${meetingPlatform === "google_calendar" ? "Google Meet" : "Zoom"}`
            : (validation.values.location || "");
        }
        if (notes && notes.trim()) {
          description += (description ? "\n\n" : "") + "Notas: " + notes.trim();
        }
        
        const updateData = {
          title: validation.values.title,
          description: description || (notes && notes.trim() ? "Notas: " + notes.trim() : ""),
          startDate: dateTime.toISOString(),
          endDate: endDateTime.toISOString(),
          location: (isReunion && meetingType === "presencial") ? validation.values.location : undefined,
          attendees: selectedLeads.map(lead => lead.email).filter(email => email),
          calendarProviderId: calendarProviderId || undefined,
          color: borderColor,
          type: selectedEventType || categoryType,
          timezone: userTimezone || "America/Mexico_City",
        };

        // Actualizar evento en el backend
        const response = await PutData(`/calendar/events/${event.id}`, updateData);
        
        if (response?.data) {
          Swal.fire({
            icon: "success",
            title: "¡Evento actualizado!",
            text: "La reunión ha sido actualizada exitosamente",
            confirmButtonColor: "#E9553E",
          });
          
          // Recargar eventos
          await loadBackendEvents();
          toggle();
          validation.resetForm();
          setSelectedDay(null);
          setSelectedLeads([]);
          setLeadSearchTerm("");
          setEvent(null);
          setIsEdit(false);
          setSelectedEventType(null);
        }
      } catch (error) {
        console.error("Error updating event:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.error?.message || "No se pudo actualizar el evento",
          confirmButtonColor: "#E9553E",
        });
      }
      return;
    }

    // Si es "Nueva Reunión" (bg-info), crear evento en el backend
    if (categoryType === "bg-info" && !isEdit) {
      if (!eventDate || !eventTime) {
        Swal.fire({
          icon: "warning",
          title: "Campos requeridos",
          text: "Por favor selecciona fecha y hora",
          confirmButtonColor: "#E9553E",
        });
        return;
      }

      if (meetingType === "virtual" && !meetingPlatform) {
        Swal.fire({
          icon: "warning",
          title: "Plataforma requerida",
          text: "Por favor selecciona una plataforma para la reunión virtual",
          confirmButtonColor: "#E9553E",
        });
        return;
      }

      try {
        // Combinar fecha y hora
        const dateTime = new Date(`${eventDate}T${eventTime}`);
        const endDateTime = new Date(dateTime.getTime() + 60 * 60 * 1000); // 1 hora por defecto

        // Obtener el proveedor de calendario si es virtual
        let calendarProviderId = null;
        if (meetingType === "virtual" && meetingPlatform) {
          const provider = calendarProviders.find(p => p.key === meetingPlatform);
          if (provider) {
            calendarProviderId = provider.id;
          }
        }

        // Preparar datos del evento
        let description = meetingType === "virtual" 
          ? `Reunión virtual vía ${meetingPlatform === "google_calendar" ? "Google Meet" : "Zoom"}`
          : (validation.values.location || "");
        if (notes && notes.trim()) {
          description += (description ? "\n\n" : "") + "Notas: " + notes.trim();
        }
        
        const eventData = {
          title: validation.values.title,
          description: description,
          startDate: dateTime.toISOString(),
          endDate: endDateTime.toISOString(),
          location: meetingType === "presencial" ? validation.values.location : undefined,
          attendees: selectedLeads.map(lead => lead.email).filter(email => email),
          customerId: selectedLeads.length > 0 ? selectedLeads[0].id : undefined, // Usar el primer lead como customerId para el evento appointment_scheduled
          calendarProviderId: calendarProviderId || undefined,
          color: borderColor,
          type: selectedEventType || categoryType,
          timezone: userTimezone || "America/Mexico_City",
        };

        // Crear evento en el backend
        const response = await PostData("/calendar/events", eventData);
        
        if (response?.data) {
          Swal.fire({
            icon: "success",
            title: "¡Evento creado!",
            text: "La reunión ha sido programada exitosamente",
            confirmButtonColor: "#E9553E",
          });
          
          // Recargar eventos
          await loadBackendEvents();
          toggle();
        }
      } catch (error) {
        console.error("Error creating event:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.error?.message || "No se pudo crear el evento",
          confirmButtonColor: "#E9553E",
        });
      }
    } else {
      // Para otros tipos de eventos (no reuniones), validar fecha y hora
      if (!eventDate || !eventTime) {
        Swal.fire({
          icon: "warning",
          title: "Campos requeridos",
          text: "Por favor selecciona fecha y hora",
          confirmButtonColor: "#E9553E",
        });
        return;
      }

      // Para otros tipos de eventos, crear en el backend si hay leads seleccionados, sino usar Redux
      const dateTime = new Date(`${eventDate}T${eventTime}`);

      // Si hay leads seleccionados, crear en el backend
      if (selectedLeads.length > 0) {
        try {
          const endDateTime = new Date(dateTime.getTime() + 60 * 60 * 1000); // 1 hora por defecto

          const eventData = {
            title: validation.values.title,
            description: notes && notes.trim() ? "Notas: " + notes.trim() : "",
            startDate: dateTime.toISOString(),
            endDate: endDateTime.toISOString(),
            attendees: selectedLeads.map(lead => lead.email).filter(email => email),
            customerId: selectedLeads.length > 0 ? selectedLeads[0].id : undefined, // Usar el primer lead como customerId para el evento appointment_scheduled
            color: borderColor,
            type: categoryType,
            timezone: userTimezone || "America/Mexico_City",
          };

          const response = await PostData("/calendar/events", eventData);
          
          if (response?.data) {
            Swal.fire({
              icon: "success",
              title: "¡Evento creado!",
              text: "El evento ha sido programado exitosamente",
              confirmButtonColor: "#E9553E",
            });
            
            await loadBackendEvents();
            toggle();
            validation.resetForm();
            setSelectedDay(null);
            setSelectedLeads([]);
            setLeadSearchTerm("");
            setNotes("");
            return;
          }
        } catch (error) {
          console.error("Error creating event:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.data?.error?.message || "No se pudo crear el evento",
            confirmButtonColor: "#E9553E",
          });
          return;
        }
      }

      // Si no hay leads, solo permitir para Tarea (bg-danger), usar el flujo normal de Redux
      if (categoryType === "bg-danger") {
        if (isEdit) {
          const updateEvent = {
            id: event.id,
            title: validation.values.title,
            classNames: categoryType,
            start: event.start,
            borderColor: borderColor,
            backgroundColor: '#ffffff',
            textColor: '#495057',
          };
          dispatch(onUpdateEvent(updateEvent));
        } else {
          const newEvent = {
            id: Math.floor(Math.random() * 100000),
            title: validation.values.title,
            start: dateTime,
            className: categoryType,
            borderColor: borderColor,
            backgroundColor: '#ffffff',
            textColor: '#495057',
          };
          dispatch(onAddNewEvent(newEvent));
        }
        
        validation.resetForm();
        setSelectedDay(null);
        setSelectedLeads([]);
        setLeadSearchTerm("");
        setNotes("");
        toggle();
      } else {
        // Si no es Tarea y no hay leads, mostrar error
        Swal.fire({
          icon: "warning",
          title: "Lead requerido",
          text: "Debes seleccionar al menos un lead para este tipo de evento",
          confirmButtonColor: "#E9553E",
        });
      }
    }
  };

  /**
   * On category darg event
   */
  const onDrag = (event) => {
    event.preventDefault();
  };

  /**
   * On calendar drop event
   */
  const onDrop = (event) => {
    // Prevenir que FullCalendar cree el evento automáticamente
    event.jsEvent.preventDefault();
    
    const date = event["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(
      year,
      month,
      day,
      currentHour,
      currentMin,
      currentSec
    );

    // Formatear fecha para el input
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    setEventDate(dateStr);
    
    // Formatear hora para el input
    const timeStr = `${String(currentHour).padStart(2, '0')}:${String(currentMin).padStart(2, '0')}`;
    setEventTime(timeStr);

    const draggedEl = event.draggedEl;
    
    // Solo procesar si es una categoría externa
    if (draggedEl.classList.contains("external-event")) {
      // Extraer el título (sin el icono)
      const title = draggedEl.innerText.trim();
      
      // Extraer el tipo de categoría (bg-primary, bg-success, etc.)
      const categoryType = Array.from(draggedEl.classList).find(cls => 
        cls.startsWith('bg-') && cls !== 'bg-white'
      ) || 'bg-primary';
      
      // Establecer el tipo de evento seleccionado
      setSelectedEventType(categoryType);
      
      // Resetear el evento y modo de edición
      setEvent(null);
      setIsEdit(false);
      setSelectedLeads([]);
      setLeadSearchTerm("");
      setMeetingType("presencial");
      setMeetingPlatform("");
      
      // Abrir el modal
      toggle();
    }
  };

  document.title = "Calendar | Upzet - React Admin & Dashboard Template";
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Upzet" breadcrumbItem="Calendario" />
          <Row className="mb-4">
            <Col xl={3}>
              <Card className="h-100">
                <CardBody>
                  <div id="external-events">
                    <br />

                    <p className="text-muted" style={{ fontSize: "0.875rem", marginTop: "1rem" }}>
                      Arrastra y suelta tu evento o haz clic en el calendario
                    </p>
                    {categories &&
                      categories.map((category, i) => (
                        <div
                          className={`${category.type} external-event fc-event`}
                          key={"cat-" + category.id}
                          draggable
                          onDrag={(event) => onDrag(event, category)}
                        >
                          <i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />
                          {category.title}
                        </div>
                      ))}
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={9}>
              <Card className="mb-0 calendar-card">
                <CardBody>
                  {/* Botón de sincronización */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0" style={{ fontWeight: 600, color: "#495057" }}>Calendario</h5>
                    {calendarProviders.length > 0 && (
                      <Dropdown isOpen={syncDropdownOpen} toggle={() => setSyncDropdownOpen(!syncDropdownOpen)}>
                        <DropdownToggle
                          disabled={syncing}
                          className="d-flex align-items-center sync-button"
                          style={{ 
                            background: "#ffffff", 
                            border: "1px solid #E9553E", 
                            color: "#E9553E",
                            fontWeight: 500
                          }}
                        >
                          <i className={`mdi ${syncing ? "mdi-loading mdi-spin" : "mdi-sync"} me-2`} style={{ color: "#E9553E" }} />
                          <span style={{ color: "#E9553E" }}>{syncing ? "Sincronizando..." : "Sincronizar"}</span>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={handleSyncAll}>
                            <i className="mdi mdi-sync me-2" />
                            Sincronizar Todos
                          </DropdownItem>
                          <DropdownItem divider />
                          {calendarProviders.map((provider) => (
                            <DropdownItem
                              key={provider.id}
                              onClick={() => handleSyncCalendar(provider.id)}
                            >
                              <i className={`${provider.icon || "mdi mdi-calendar"} me-2`} />
                              {provider.displayName}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    )}
                  </div>

                  {loadingEvents && (
                    <div className="text-center py-3">
                      <Loader message="Cargando eventos..." />
                    </div>
                  )}

                  {/* fullcalendar control */}
                  <div style={{ background: "#ffffff", borderRadius: "0.375rem", padding: "1rem" }}>
                  <FullCalendar
                    plugins={[BootstrapTheme, dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    slotDuration={"00:15:00"}
                    handleWindowResize={true}
                    themeSystem="bootstrap"
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    initialView="dayGridMonth"
                    events={backendEvents}
                    editable={true}
                    droppable={true}
                    selectable={true}
                    dateClick={handleDateClick}
                    eventClick={handleEventClick}
                    drop={onDrop}
                    eventReceive={(eventInfo) => {
                      // Prevenir que FullCalendar cree el evento automáticamente
                      // Ya lo creamos manualmente en onDrop
                      eventInfo.event.remove();
                    }}
                    locale="es"
                    height="auto"
                    allDaySlot={true}
                  />
                  </div>

                  {/* New/Edit event modal */}
                  <Modal isOpen={modal} className={`${props.className} calendar-modal`} size="lg">
                    <ModalHeader toggle={toggle} tag="h4" style={{ fontWeight: 600, color: "#495057" }}>
                      {!!isEdit ? "Editar Evento" : selectedEventType ? categories.find(c => c.type === selectedEventType)?.title || "Nuevo Evento" : "Nuevo Evento"}
                    </ModalHeader>
                    <ModalBody>
                      {!selectedEventType && !isEdit ? (
                        // Selector de tipo de evento
                        <div>
                          <Label className="form-label mb-3" style={{ fontWeight: 600 }}>
                            Selecciona el tipo de evento:
                          </Label>
                          <Row>
                            {categories && categories.map((category) => (
                              <Col md={6} key={category.id} className="mb-3">
                                <div
                                  className="card border cursor-pointer h-100"
                                  style={{
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                    borderColor: "#e9ecef"
                                  }}
                                  onClick={() => {
                                    setSelectedEventType(category.type);
                                    validation.setFieldValue("category", category.type);
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = "#E9553E";
                                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(233, 85, 62, 0.2)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = "#e9ecef";
                                    e.currentTarget.style.boxShadow = "none";
                                  }}
                                >
                                  <div className="card-body text-center p-3">
                                    <i className={`mdi mdi-checkbox-blank-circle font-size-24 mb-2`} 
                                       style={{ color: category.type === "bg-primary" ? "#E9553E" : 
                                                       category.type === "bg-success" ? "#0ac074" :
                                                       category.type === "bg-warning" ? "#fcb92c" :
                                                       category.type === "bg-danger" ? "#ff3d60" :
                                                       category.type === "bg-info" ? "#4aa3ff" :
                                                       category.type === "bg-dark" ? "#343a40" : "#74788d" }}
                                    />
                                    <h6 className="mb-0">{category.title}</h6>
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </Row>
                          <div className="text-end mt-3">
                            <button
                              type="button"
                              className="btn btn-light"
                              onClick={toggle}
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      ) : (
                        // Formulario específico según el tipo de evento
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleEventSubmit();
                          return false;
                        }}
                        onClick={(e) => {
                          // Permitir que los clicks en inputs y labels se propaguen
                          if (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL' || e.target.closest('input') || e.target.closest('label')) {
                            return;
                          }
                        }}
                      >
                          {selectedEventType === "bg-primary" ? (
                            // Formulario para "Enviar Correo"
                            <>
                        <Row>
                          <Col className="col-12 mb-3">
                                  <Label className="form-label">Asunto del Correo <span className="text-danger">*</span></Label>
                            <Input
                              name="title"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.title || ""}
                                    placeholder="Ej: Seguimiento de propuesta"
                                    invalid={validation.touched.title && validation.errors.title ? true : false}
                                  />
                                  {validation.touched.title && validation.errors.title ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.title}
                                    </FormFeedback>
                                  ) : null}
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6} className="mb-3">
                                  <Label className="form-label">Fecha <span className="text-danger">*</span></Label>
                                  <Input
                                    type="date"
                                    value={eventDate}
                                    onChange={(e) => setEventDate(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                    required
                                  />
                                  <small className="text-muted d-block mt-1">No se pueden seleccionar fechas anteriores a hoy</small>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <Label className="form-label">Hora <span className="text-danger">*</span></Label>
                                  <Input
                                    type="time"
                                    value={eventTime}
                                    onChange={(e) => setEventTime(e.target.value)}
                                    required
                                  />
                                </Col>
                              </Row>

                              {/* Selector de Leads con búsqueda */}
                              <Row>
                                <Col className="col-12 mb-3">
                                  <Label className="form-label">Destinatarios <span className="text-danger">*</span></Label>
                                  <Input
                                    type="text"
                                    placeholder="Buscar por nombre, apellido, email o teléfono..."
                                    value={leadSearchTerm}
                                    onChange={(e) => setLeadSearchTerm(e.target.value)}
                                    className="mb-2"
                                  />
                                  {loadingLeads ? (
                                    <div className="text-center py-3">
                                      <Loader message="Cargando leads..." />
                                    </div>
                                  ) : (
                                    <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "0.375rem", padding: "0.5rem" }}>
                                      {!leadSearchTerm || leadSearchTerm.trim().length === 0 ? (
                                        <p className="text-muted text-center mb-0">Escribe para buscar leads...</p>
                                      ) : leads.length === 0 ? (
                                        <p className="text-muted text-center mb-0">No se encontraron leads</p>
                                      ) : (
                                        leads.map((lead) => {
                                          const isSelected = selectedLeads.some(l => l.id === lead.id);
                                          return (
                                            <div key={lead.id} className="form-check mb-2">
                                              <input
                                                type="checkbox"
                                                id={`lead-email-${lead.id}`}
                                                className="form-check-input"
                                                checked={isSelected}
                                                onChange={(e) => {
                                                  e.stopPropagation();
                                                  if (e.target.checked) {
                                                    setSelectedLeads([...selectedLeads, lead]);
                                                  } else {
                                                    setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                  }
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                              <label 
                                                className="form-check-label" 
                                                htmlFor={`lead-email-${lead.id}`}
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (isSelected) {
                                                    setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                  } else {
                                                    setSelectedLeads([...selectedLeads, lead]);
                                                  }
                                                }}
                                              >
                                                <strong>{`${lead.name || ""} ${lead.lastName || ""}`.trim() || "Sin nombre"}</strong>
                                                {lead.email && <span className="text-muted ms-2">({lead.email})</span>}
                                                {!lead.email && lead.phone && <span className="text-muted ms-2">({lead.phone})</span>}
                                              </label>
                                            </div>
                                          );
                                        })
                                      )}
                                    </div>
                                  )}
                                  {selectedLeads.length > 0 && (
                                    <div className="mt-2">
                                      <small className="text-muted">Destinatarios seleccionados: </small>
                                      <div className="d-flex flex-wrap gap-2 mt-2">
                                        {selectedLeads.map((lead) => (
                                          <Badge 
                                            key={lead.id} 
                                            color="info" 
                                            className="d-inline-flex align-items-center"
                                            style={{ fontSize: "0.875rem", padding: "0.5rem 0.75rem" }}
                                          >
                                            <span>
                                              {`${lead.name || ""} ${lead.lastName || ""}`.trim() || lead.email || "Sin nombre"}
                                            </span>
                                            <button
                                              type="button"
                                              className="btn-close btn-close-white ms-2"
                                              style={{ 
                                                fontSize: "0.6rem",
                                                padding: "0",
                                                margin: "0",
                                                opacity: "0.8"
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                              }}
                                              aria-label="Eliminar"
                                            />
                                          </Badge>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                  {selectedLeads.length === 0 && (
                                    <FormFeedback type="invalid" style={{ display: "block" }}>
                                      Debes seleccionar al menos un destinatario
                                    </FormFeedback>
                                  )}
                                </Col>
                              </Row>

                              <Row>
                                <Col className="col-12 mb-3">
                                  <Label className="form-label">Notas</Label>
                                  <Input
                                    type="textarea"
                                    rows="4"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    placeholder="Notas adicionales sobre el correo a enviar..."
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : (selectedEventType === "bg-info" || (isEdit && event?.isBackendEvent && (event?.backendEventData?.meetingUrl || event?.backendEventData?.calendarProviderId))) ? (
                            // Formulario para "Nueva Reunión" o edición de evento del backend que es reunión
                            <>
                        <Row>
                          <Col className="col-12 mb-3">
                                  <Label className="form-label">Título de la Reunión</Label>
                            <Input
                              name="title"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.title || ""}
                                    placeholder="Ej: Reunión con cliente"
                                    invalid={validation.touched.title && validation.errors.title ? true : false}
                                  />
                                  {validation.touched.title && validation.errors.title ? (
                              <FormFeedback type="invalid">
                                {validation.errors.title}
                              </FormFeedback>
                            ) : null}
                          </Col>
                              </Row>

                              <Row>
                          <Col className="col-12 mb-3">
                                  <Label className="form-label">Tipo de Reunión</Label>
                                  <FormGroup>
                                    <div className="form-check mb-2">
                                      <input
                                        type="radio"
                                        name="meetingType"
                                        id="presencial"
                                        className="form-check-input"
                                        value="presencial"
                                        checked={meetingType === "presencial"}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          setMeetingType(e.target.value);
                                          if (e.target.value === "presencial") {
                                            setMeetingPlatform("");
                                          }
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      />
                                      <Label 
                                        className="form-check-label" 
                                        htmlFor="presencial" 
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setMeetingType("presencial");
                                          setMeetingPlatform("");
                                        }}
                                      >
                                        Presencial
                            </Label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        type="radio"
                                        name="meetingType"
                                        id="virtual"
                                        className="form-check-input"
                                        value="virtual"
                                        checked={meetingType === "virtual"}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          setMeetingType(e.target.value);
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      />
                                      <Label 
                                        className="form-check-label" 
                                        htmlFor="virtual" 
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setMeetingType("virtual");
                                        }}
                                      >
                                        Virtual
                                      </Label>
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>

                              {meetingType === "virtual" && (
                                <Row>
                                  <Col className="col-12 mb-3">
                                    <Label className="form-label">Plataforma <span className="text-danger">*</span></Label>
                                    {calendarProviders.filter(p => (p.key === "google_calendar" || p.key === "zoom") && p.status === "connected").length > 0 ? (
                            <Input
                              type="select"
                                        value={meetingPlatform}
                                        onChange={(e) => setMeetingPlatform(e.target.value)}
                                        required
                                        invalid={meetingType === "virtual" && !meetingPlatform}
                                      >
                                        <option value="">--Seleccionar plataforma--</option>
                                        {calendarProviders
                                          .filter(p => (p.key === "google_calendar" || p.key === "zoom") && p.status === "connected")
                                          .map((provider) => (
                                            <option key={provider.id} value={provider.key}>
                                              {provider.key === "google_calendar" ? "Google Meet" : "Zoom"}
                                            </option>
                                          ))}
                                      </Input>
                                    ) : (
                                      <div>
                                        <Input type="select" disabled>
                                          <option>No hay plataformas disponibles</option>
                                        </Input>
                                        <small className="text-muted">
                                          No hay plataformas de videollamada configuradas. Configúralas en "Configurar Proveedores".
                                        </small>
                                      </div>
                                    )}
                                    {meetingType === "virtual" && !meetingPlatform && (
                                      <FormFeedback type="invalid">
                                        Debes seleccionar una plataforma para reuniones virtuales
                                      </FormFeedback>
                                    )}
                                  </Col>
                                </Row>
                              )}

                              {meetingType === "presencial" && (
                                <Row>
                                  <Col className="col-12 mb-3">
                                    <Label className="form-label">Ubicación</Label>
                                    <Input
                                      type="text"
                                      name="location"
                                      placeholder="Ej: Oficina principal, Calle 123"
                              onChange={validation.handleChange}
                                    />
                                  </Col>
                                </Row>
                              )}

                              <Row>
                                <Col md={6} className="mb-3">
                                  <Label className="form-label">Fecha <span className="text-danger">*</span></Label>
                                  <Input
                                    type="date"
                                    value={eventDate}
                                    onChange={(e) => setEventDate(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                    required
                                  />
                                  <small className="text-muted d-block mt-1">No se pueden seleccionar fechas anteriores a hoy</small>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <Label className="form-label">Hora <span className="text-danger">*</span></Label>
                                  <Input
                                    type="time"
                                    value={eventTime}
                                    onChange={(e) => setEventTime(e.target.value)}
                                    required
                                  />
                                </Col>
                              </Row>

                              {/* Selector de Leads con búsqueda - Reutilizable */}
                              <Row>
                                <Col className="col-12 mb-3">
                                  <Label className="form-label">Seleccionar Leads</Label>
                                  <Input
                                    type="text"
                                    placeholder="Buscar por nombre, apellido, email o teléfono..."
                                    value={leadSearchTerm}
                                    onChange={(e) => setLeadSearchTerm(e.target.value)}
                                    className="mb-2"
                                  />
                                  {loadingLeads ? (
                                    <div className="text-center py-3">
                                      <Loader message="Cargando leads..." />
                                    </div>
                                  ) : (
                                    <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "0.375rem", padding: "0.5rem" }}>
                                      {!leadSearchTerm || leadSearchTerm.trim().length === 0 ? (
                                        <p className="text-muted text-center mb-0">Escribe para buscar leads...</p>
                                      ) : leads.length === 0 ? (
                                        <p className="text-muted text-center mb-0">No se encontraron leads</p>
                                      ) : (
                                        leads.map((lead) => {
                                          const isSelected = selectedLeads.some(l => l.id === lead.id);
                                          return (
                                            <div key={lead.id} className="form-check mb-2">
                                              <input
                                                type="checkbox"
                                                id={`lead-${lead.id}`}
                                                className="form-check-input"
                                                checked={isSelected}
                                                onChange={(e) => {
                                                  e.stopPropagation();
                                                  if (e.target.checked) {
                                                    setSelectedLeads([...selectedLeads, lead]);
                                                  } else {
                                                    setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                  }
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                              <label 
                                                className="form-check-label" 
                                                htmlFor={`lead-${lead.id}`}
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (isSelected) {
                                                    setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                  } else {
                                                    setSelectedLeads([...selectedLeads, lead]);
                                                  }
                                                }}
                                              >
                                                <strong>{`${lead.name || ""} ${lead.lastName || ""}`.trim() || "Sin nombre"}</strong>
                                                {lead.email && <span className="text-muted ms-2">({lead.email})</span>}
                                                {!lead.email && lead.phone && <span className="text-muted ms-2">({lead.phone})</span>}
                                              </label>
                                            </div>
                                          );
                                        })
                                      )}
                                    </div>
                                  )}
                                  {selectedLeads.length > 0 && (
                                    <div className="mt-2">
                                      <small className="text-muted">Leads seleccionados: </small>
                                      <div className="d-flex flex-wrap gap-2 mt-2">
                                        {selectedLeads.map((lead) => (
                                          <Badge 
                                            key={lead.id} 
                                            color="info" 
                                            className="d-inline-flex align-items-center"
                                            style={{ fontSize: "0.875rem", padding: "0.5rem 0.75rem" }}
                                          >
                                            <span>
                                              {`${lead.name || ""} ${lead.lastName || ""}`.trim() || lead.email || "Sin nombre"}
                                            </span>
                                            <button
                                              type="button"
                                              className="btn-close btn-close-white ms-2"
                                              style={{ 
                                                fontSize: "0.6rem",
                                                padding: "0",
                                                margin: "0",
                                                opacity: "0.8"
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                              }}
                                              aria-label="Eliminar"
                                            />
                                          </Badge>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </Col>
                              </Row>

                              <Row>
                                <Col className="col-12 mb-3">
                                  <Label className="form-label">Notas</Label>
                                  <Input
                                    type="textarea"
                                    rows="4"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    placeholder="Notas adicionales sobre la reunión..."
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : (
                            // Formulario genérico para otros tipos de eventos
                            <>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <Label className="form-label">Nombre del Evento <span className="text-danger">*</span></Label>
                                  <Input
                                    name="title"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.title || ""}
                                    invalid={validation.touched.title && validation.errors.title ? true : false}
                                  />
                                  {validation.touched.title && validation.errors.title ? (
                              <FormFeedback type="invalid">
                                      {validation.errors.title}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        </Row>
                              <Row>
                                <Col md={6} className="mb-3">
                                  <Label className="form-label">Fecha <span className="text-danger">*</span></Label>
                                  <Input
                                    type="date"
                                    value={eventDate}
                                    onChange={(e) => setEventDate(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                    required
                                  />
                                  <small className="text-muted d-block mt-1">No se pueden seleccionar fechas anteriores a hoy</small>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <Label className="form-label">Hora <span className="text-danger">*</span></Label>
                                  <Input
                                    type="time"
                                    value={eventTime}
                                    onChange={(e) => setEventTime(e.target.value)}
                                    required
                                  />
                                </Col>
                              </Row>

                              {/* Selector de Leads - Solo si no es Tarea (bg-danger) */}
                              {selectedEventType !== "bg-danger" && (
                                <Row>
                                  <Col className="col-12 mb-3">
                                    <Label className="form-label">Seleccionar Leads <span className="text-danger">*</span></Label>
                                    <Input
                                      type="text"
                                      placeholder="Buscar por nombre, apellido, email o teléfono..."
                                      value={leadSearchTerm}
                                      onChange={(e) => setLeadSearchTerm(e.target.value)}
                                      className="mb-2"
                                    />
                                    {loadingLeads ? (
                                      <div className="text-center py-3">
                                        <Loader message="Cargando leads..." />
                                      </div>
                                    ) : (
                                      <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "0.375rem", padding: "0.5rem" }}>
                                        {!leadSearchTerm || leadSearchTerm.trim().length === 0 ? (
                                          <p className="text-muted text-center mb-0">Escribe para buscar leads...</p>
                                        ) : leads.length === 0 ? (
                                          <p className="text-muted text-center mb-0">No se encontraron leads</p>
                                        ) : (
                                          leads.map((lead) => {
                                            const isSelected = selectedLeads.some(l => l.id === lead.id);
                                            return (
                                              <div key={lead.id} className="form-check mb-2">
                                                <input
                                                  type="checkbox"
                                                  id={`lead-generic-${lead.id}`}
                                                  className="form-check-input"
                                                  checked={isSelected}
                                                  onChange={(e) => {
                                                    e.stopPropagation();
                                                    if (e.target.checked) {
                                                      setSelectedLeads([...selectedLeads, lead]);
                                                    } else {
                                                      setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                    }
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                  }}
                                                />
                                                <label 
                                                  className="form-check-label" 
                                                  htmlFor={`lead-generic-${lead.id}`}
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (isSelected) {
                                                      setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                    } else {
                                                      setSelectedLeads([...selectedLeads, lead]);
                                                    }
                                                  }}
                                                >
                                                  <strong>{`${lead.name || ""} ${lead.lastName || ""}`.trim() || "Sin nombre"}</strong>
                                                  {lead.email && <span className="text-muted ms-2">({lead.email})</span>}
                                                  {!lead.email && lead.phone && <span className="text-muted ms-2">({lead.phone})</span>}
                                                </label>
                                              </div>
                                            );
                                          })
                                        )}
                                      </div>
                                    )}
                                    {selectedLeads.length > 0 && (
                                      <div className="mt-2">
                                        <small className="text-muted">Leads seleccionados: </small>
                                        <div className="d-flex flex-wrap gap-2 mt-2">
                                          {selectedLeads.map((lead) => (
                                            <Badge 
                                              key={lead.id} 
                                              color="info" 
                                              className="d-inline-flex align-items-center"
                                              style={{ fontSize: "0.875rem", padding: "0.5rem 0.75rem" }}
                                            >
                                              <span>
                                                {`${lead.name || ""} ${lead.lastName || ""}`.trim() || lead.email || "Sin nombre"}
                                              </span>
                                              <button
                                                type="button"
                                                className="btn-close btn-close-white ms-2"
                                                style={{ 
                                                  fontSize: "0.6rem",
                                                  padding: "0",
                                                  margin: "0",
                                                  opacity: "0.8"
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setSelectedLeads(selectedLeads.filter(l => l.id !== lead.id));
                                                }}
                                                aria-label="Eliminar"
                                              />
                                            </Badge>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                    {selectedLeads.length === 0 && (
                                      <FormFeedback type="invalid" style={{ display: "block" }}>
                                        Debes seleccionar al menos un lead
                                      </FormFeedback>
                                    )}
                                  </Col>
                                </Row>
                              )}

                              <Row>
                                <Col className="col-12 mb-3">
                                  <Label className="form-label">Notas</Label>
                                  <Input
                                    type="textarea"
                                    rows="4"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    placeholder="Notas adicionales sobre el evento..."
                                  />
                                </Col>
                              </Row>
                            </>
                          )}

                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="button"
                                className="btn btn-light me-2"
                                  onClick={() => {
                                    if (selectedEventType && !isEdit) {
                                      setSelectedEventType(null);
                                    } else {
                                      toggle();
                                    }
                                  }}
                                >
                                  {selectedEventType && !isEdit ? "Atrás" : "Cerrar"}
                              </button>
                              {!!isEdit && (
                                <button
                                  type="button"
                                  className="btn btn-danger me-2"
                                  onClick={() => setDeleteModal(true)}
                                >
                                    Eliminar
                                </button>
                              )}
                              <button
                                type="submit"
                                  className="btn btn-success"
                                  style={{ background: "#E9553E", borderColor: "#E9553E" }}
                              >
                                  Guardar
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                      )}
                    </ModalBody>
                  </Modal>

                  <Modal
                    isOpen={modalcategory}
                    toggle={toggleCategory}
                    className={props.className}
                  >
                    <ModalHeader toggle={toggleCategory} tag="h4">
                      Agregar Categoría
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          categoryValidation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col className="col-12 mb-3">
                            <Label className="form-label">Nombre del Evento</Label>
                            <Input
                              name="title"
                              type="text"
                              // value={event ? event.title : ""}
                              onChange={categoryValidation.handleChange}
                              onBlur={categoryValidation.handleBlur}
                              value={categoryValidation.values.title || ""}
                              invalid={
                                categoryValidation.touched.title &&
                                categoryValidation.errors.title
                                  ? true
                                  : false
                              }
                            />
                            {categoryValidation.touched.title &&
                            categoryValidation.errors.title ? (
                              <FormFeedback type="invalid">
                                {categoryValidation.errors.title}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col className="col-12 mb-3">
                            <Label className="form-label">
                              Seleccionar Categoría
                            </Label>
                            <Input
                              type="select"
                              name="category"
                              // value={event ? event.category : "bg-primary"}
                              onChange={categoryValidation.handleChange}
                              onBlur={categoryValidation.handleBlur}
                              value={categoryValidation.values.category || ""}
                              invalid={
                                categoryValidation.touched.category &&
                                categoryValidation.errors.category
                                  ? true
                                  : false
                              }
                            >
                              <option defaultValue> --Seleccionar-- </option>
                              <option value="bg-danger">Peligro</option>
                              <option value="bg-success">Éxito</option>
                              <option value="bg-primary">Principal</option>
                              <option value="bg-info">Información</option>
                              <option value="bg-dark">Oscuro</option>
                              <option value="bg-warning">Advertencia</option>
                            </Input>
                            {categoryValidation.touched.category &&
                            categoryValidation.errors.category ? (
                              <FormFeedback type="invalid">
                                {categoryValidation.errors.category}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="button"
                                className="btn btn-light me-2"
                                onClick={toggleCategory}
                              >
                                Cerrar
                              </button>
                              <button
                                type="submit"
                                className="btn btn-success save-event"
                              >
                                Guardar
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>

                  {/* Event Details Modal */}
                  <Modal isOpen={eventDetailsModal} toggle={() => setEventDetailsModal(false)} className={`${props.className} calendar-modal`}>
                    <ModalHeader toggle={() => setEventDetailsModal(false)} tag="h4" style={{ fontWeight: 600, color: "#495057" }}>
                      Detalles del Evento
                    </ModalHeader>
                    <ModalBody>
                      {selectedEventDetails && (
                        <div>
                          <Row className="mb-3">
                            <Col>
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">{selectedEventDetails.title}</h5>
                                {selectedEventDetails.typeName && (
                                  <Badge 
                                    style={{
                                      backgroundColor: selectedEventDetails.type === 'bg-primary' ? '#E9553E' :
                                                       selectedEventDetails.type === 'bg-success' ? '#0ac074' :
                                                       selectedEventDetails.type === 'bg-warning' ? '#fcb92c' :
                                                       selectedEventDetails.type === 'bg-danger' ? '#ff3d60' :
                                                       selectedEventDetails.type === 'bg-info' ? '#4aa3ff' :
                                                       selectedEventDetails.type === 'bg-dark' ? '#343a40' : '#74788d',
                                      color: 'white',
                                      padding: '0.25rem 0.75rem',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    {selectedEventDetails.typeName}
                                  </Badge>
                                )}
                              </div>
                              {selectedEventDetails.description && (
                                <p className="text-muted mt-2">{selectedEventDetails.description}</p>
                              )}
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col md={6}>
                              <strong>Fecha de inicio:</strong>
                              <p>{new Date(selectedEventDetails.start).toLocaleString('es-ES', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}</p>
                            </Col>
                            <Col md={6}>
                              <strong>Fecha de fin:</strong>
                              <p>{new Date(selectedEventDetails.end).toLocaleString('es-ES', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}</p>
                            </Col>
                          </Row>

                          {selectedEventDetails.location && (
                            <Row className="mb-3">
                              <Col>
                                <strong>Ubicación:</strong>
                                <p>{selectedEventDetails.location}</p>
                              </Col>
                            </Row>
                          )}

                          {selectedEventDetails.meetingUrl && (
                            <Row className="mb-3">
                              <Col>
                                <strong>Enlace de reunión:</strong>
                                <p>
                                  <a 
                                    href={selectedEventDetails.meetingUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-primary"
                                  >
                                    {selectedEventDetails.meetingUrl.includes('zoom.us') ? '🔗 Zoom Meeting' : 
                                     selectedEventDetails.meetingUrl.includes('meet.google.com') ? '🔗 Google Meet' : 
                                     '🔗 Enlace de reunión'}
                                  </a>
                                </p>
                              </Col>
                            </Row>
                          )}

                          {/* Respuestas del chat.
                              Una cita agendada por un Sales Agent trae lo que
                              la persona contestó: las preguntas propias del
                              tipo de cita en Calendly y lo que preguntó el
                              guion. Sin esto, el asesor abre la cita y no sabe
                              con quién va a hablar ni de qué. */}
                          {(() => {
                            const meta = selectedEventDetails.eventData?.metadata || {};
                            // Las preguntas de Calendly llegan como lista
                            // [{pregunta, respuesta}]. Las citas guardadas antes
                            // del cambio traían un objeto; se aceptan las dos.
                            const crudo = meta.respuestas;
                            const deCalendly = Array.isArray(crudo)
                              ? crudo.map((r) => [r.pregunta, r.respuesta])
                              : (crudo && typeof crudo === 'object' ? Object.entries(crudo) : null);
                            const delGuion = meta.conversacion && typeof meta.conversacion === 'object'
                              ? Object.entries(meta.conversacion)
                              : null;
                            if (!deCalendly?.length && !delGuion?.length) return null;

                            const fila = (k, v) => (
                              <li key={k} className="mb-2">
                                <small className="text-muted d-block">{k}</small>
                                <span>{typeof v === 'object' ? JSON.stringify(v) : String(v)}</span>
                              </li>
                            );

                            return (
                              <Row className="mb-3">
                                <Col>
                                  <strong>Respuestas</strong>
                                  {meta.campana && (
                                    <Badge className="ms-2" style={{ backgroundColor: '#74788d', color: '#fff' }}>
                                      {meta.campana}
                                    </Badge>
                                  )}
                                  <ul className="list-unstyled mt-2 mb-0">
                                    {deCalendly && deCalendly.map(([k, v]) => fila(k, v))}
                                    {delGuion && delGuion.map(([k, v]) => fila(k, v))}
                                  </ul>
                                </Col>
                              </Row>
                            );
                          })()}

                          {selectedEventDetails.attendees && selectedEventDetails.attendees.length > 0 && (
                            <Row className="mb-3">
                              <Col>
                                <strong>Invitados:</strong>
                                <ul className="list-unstyled mt-2">
                                  {selectedEventDetails.attendees.map((email, index) => {
                                    // Buscar información del lead si existe
                                    const attendeeInfo = selectedEventDetails.attendeesInfo?.find(
                                      (info) => info.email === email
                                    );
                                    
                                    return (
                                      <li key={index} className="mb-2">
                                        {attendeeInfo && attendeeInfo.fullName ? (
                                          <div>
                                            <strong>{attendeeInfo.fullName}</strong>
                                            <br />
                                            <small className="text-muted">{email}</small>
                                            {attendeeInfo.customerId && (
                                              <span className="badge bg-info ms-2">Lead en CRM</span>
                                            )}
                                          </div>
                                        ) : (
                                          <span>{email}</span>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </Col>
                            </Row>
                          )}

                          <Row>
                            <Col>
                              <div className="text-end">
                                {selectedEventDetails.isBackendEvent && (
                                  <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    style={{ backgroundColor: "#E9553E", borderColor: "#E9553E" }}
                                    onClick={async () => {
                                      // Cerrar modal de detalles
                                      setEventDetailsModal(false);
                                      
                                      // Cargar datos para edición
                                      try {
                                        await loadEventForEditing(selectedEventDetails.id, selectedEventDetails.eventData);
                                        // Abrir modal de edición
                                        toggle();
                                      } catch (error) {
                                        console.error("Error loading event for editing:", error);
                                        Swal.fire({
                                          icon: "error",
                                          title: "Error",
                                          text: "No se pudo cargar el evento para edición",
                                          confirmButtonColor: "#E9553E",
                                        });
                                      }
                                    }}
                                  >
                                    Editar
                                  </button>
                                )}
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => setEventDetailsModal(false)}
                                >
                                  Cerrar
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Calender.propTypes = {
  events: PropTypes.array,
  categories: PropTypes.array,
  className: PropTypes.string,
  onGetEvents: PropTypes.func,
  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onGetCategories: PropTypes.func,
};

export default Calender;
